(function () {
  const cards = document.querySelectorAll('[data-category-card]');
  if (!cards.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  cards.forEach((card) => {
    const video = card.querySelector('[data-category-video]');
    if (!video) return;

    const play = () => {
      if (reducedMotion.matches) return;
      if (video.preload === 'none' || video.preload === 'metadata') video.preload = 'auto';
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };

    const pause = () => {
      video.pause();
    };

    card.addEventListener('mouseenter', () => {
      if (!card.classList.contains('is-active')) play();
    });
    card.addEventListener('mouseleave', () => {
      if (!card.classList.contains('is-active')) pause();
    });
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', (event) => {
      if (!card.contains(event.relatedTarget)) pause();
    });

    card.addEventListener('touchstart', () => {
      card.classList.add('is-active');
      play();
    }, { passive: true });
  });

  document.addEventListener('touchstart', (event) => {
    cards.forEach((card) => {
      if (!card.contains(event.target) && card.classList.contains('is-active')) {
        card.classList.remove('is-active');
        const video = card.querySelector('[data-category-video]');
        if (video) video.pause();
      }
    });
  }, { passive: true });
})();
